'use strict';

import './nativeTwinAd.scss';
import template from './nativeTwinAd.template.html';
import controller from './nativeTwinAd.controller.js';

const component = {
    bindings: {
        targeting: '=',
        defaultTargeting: '@',
        slotNames: '='
    },
    controller,
    template
};

export default component;
